import React, { useContext, useEffect } from 'react';
import { StateContext } from '../../../Util/StateContext/StateContext';
import { useForm } from 'react-hook-form';
import { REQUEST_ENDPOINT } from '../../../Util/FetchAPI/FetchAPI';

import { ValidationErrorComponent } from './ValidationErrorComponent/ValidationErrorComponent';

const RequestCartForm = ({ requests }) => {
    const { register, handleSubmit, watch, formState } = useForm();
    const { state, dispatch } = useContext(StateContext);


    const GOVT_CONTRACT = watch('govt_contract');
    const ENGINE_VARIANT = watch('engine_variant');

    useEffect(() => {
        if (state.requests.length === 0) {
            dispatch({ type: 'TOGGLE_FORM_DRAWER', payload: false });
        }
    }, [state.requests, dispatch]);


    const onSubmit = (data) => {
        //toggle is submitting to transistion to loading state
        //create form data
        window.scrollTo({ top: 0, behavior: 'smooth' });
        dispatch({ type: 'TOGGLE_LOADER' });
        dispatch({ type: 'SET_LOADING_MESSAGE', payload: "Submitting Form" });

        const formData = new FormData();

        const requestsObj = requests.map((item) => {
            return {
                id: item.id,
                quantity: item.qty
            }
        });

        for (const key in data) {
            // console.log(data[key]);
            formData.append(key, data[key]);
        }
        formData.append("requests", JSON.stringify(requestsObj));
        console.log(formData);

        // post form data
        fetch(REQUEST_ENDPOINT, {
            method: 'POST',
            // mode: "no-cors",
            body: formData,
        })
            .then(response => response.json())
            .then(res => {
                console.log(res);
                if (res.success) {
                    dispatch({ type: 'SET_LOADING_MESSAGE', payload: "Submission Successful!" });
                    setTimeout(() => {
                        window.location.href = 'https://www.rhinestahl.com/cts/catalog/thank-you?request_submitted=true';
                        dispatch({ type: 'RESET_STATE' });
                    }, 3000);
                }
            })
            .catch(error => {
                console.error('Form submission error:', error);
            });
    }

    return (
        <div id="form-drawer" className={state.formDrawerOpen ? "form-drawer open" : "form-drawer"}>
            <div id="request-cart-form">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="firstName">First name<span>*</span></label>
                            <input type="text" id="firstName" placeholder="First name" {...register("firstName", { required: true, maxLength: 80 })}
                                aria-invalid={formState.errors.name ? "true" : "false"}
                            />
                            <ValidationErrorComponent
                                error={formState.errors.firstName}
                                type="required"
                                message="A first name is required."
                            />
                            <ValidationErrorComponent
                                error={formState.errors.firstName}
                                type="maxLength"
                                message="Max length exceeded."
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lastName">Last name<span>*</span></label>
                            <input type="text" id="lastName" placeholder="Last name" {...register("lastName", { required: true, maxLength: 100 })} />
                            <ValidationErrorComponent
                                error={formState.errors.lastName}
                                type="required"
                                message="A last name is required."
                            />
                            <ValidationErrorComponent
                                error={formState.errors.lastName}
                                type="maxLength"
                                message="Max length exceeded."
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="company">Company<span>*</span></label>
                        <input type="text" placeholder="Company" {...register("company", {})} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email<span>*</span></label>
                        <input type="text" id="email" placeholder="Email" {...register("email", { required: true, pattern: /^\S+@\S+$/i })} />
                        <ValidationErrorComponent
                            error={formState.errors.email}
                            type="required"
                            message="An email address is required."
                        />
                        <ValidationErrorComponent
                            error={formState.errors.email}
                            type="pattern"
                            message="This email address is invalid."
                        />

                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Phone<span>*</span></label>
                        <input type="tel" id="phone" placeholder="Phone" {...register("phone", { required: true })} />
                        <ValidationErrorComponent
                            error={formState.errors.phone}
                            type="required"
                            message="A phone number is required."
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="address">Address<span>*</span></label>
                        <input type="text" id="address" placeholder="1234 Main St" {...register("address", { required: true, maxLength: 100 })} />
                        <ValidationErrorComponent
                            error={formState.errors.address}
                            type="required"
                            message="An address is required."
                        />
                        <ValidationErrorComponent
                            error={formState.errors.address}
                            type="maxLength"
                            message="Max length exceeded."
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="address2">Address 2</label>
                        <input type="text" id="address2" placeholder="" {...register("address2", { maxLength: 100 })} />
                        <ValidationErrorComponent
                            error={formState.errors.address2}
                            type="maxLength"
                            message="Max length exceeded."
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="city">City<span>*</span></label>
                            <input type="text" placeholder="City" id="city" {...register("city", { required: true, maxLength: 100 })} />
                            <ValidationErrorComponent
                                error={formState.errors.city}
                                type="required"
                                message="A city is required."
                            />
                            <ValidationErrorComponent
                                error={formState.errors.city}
                                type="maxLength"
                                message="Max length exceeded."
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="state">State/Province<span>*</span></label>
                            <input type="text" placeholder="State/Province" id="state" {...register("state", { required: true, maxLength: 100 })} />
                            <ValidationErrorComponent
                                error={formState.errors.state}
                                type="required"
                                message="A state is required."
                            />
                            <ValidationErrorComponent
                                error={formState.errors.state}
                                type="maxLength"
                                message="Max length exceeded."
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="country">Country<span>*</span></label>
                            <select id="country" {...register("country", { required: true })}>
                                <option value="Afganistan">Afghanistan</option>
                                <option value="Albania">Albania</option>
                                <option value="Algeria">Algeria</option>
                                <option value="American Samoa">American Samoa</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Angola">Angola</option>
                                <option value="Anguilla">Anguilla</option>
                                <option value="Antigua & Barbuda">Antigua & Barbuda</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Aruba">Aruba</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas">Bahamas</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Benin">Benin</option>
                                <option value="Bermuda">Bermuda</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Bonaire">Bonaire</option>
                                <option value="Bosnia & Herzegovina">Bosnia & Herzegovina</option>
                                <option value="Botswana">Botswana</option>
                                <option value="Brazil">Brazil</option>
                                <option value="British Indian Ocean Ter">British Indian Ocean Ter</option>
                                <option value="Brunei">Brunei</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Burkina Faso">Burkina Faso</option>
                                <option value="Burundi">Burundi</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Canada">Canada</option>
                                <option value="Canary Islands">Canary Islands</option>
                                <option value="Cape Verde">Cape Verde</option>
                                <option value="Cayman Islands">Cayman Islands</option>
                                <option value="Central African Republic">Central African Republic</option>
                                <option value="Chad">Chad</option>
                                <option value="Channel Islands">Channel Islands</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Christmas Island">Christmas Island</option>
                                <option value="Cocos Island">Cocos Island</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Comoros">Comoros</option>
                                <option value="Congo">Congo</option>
                                <option value="Cook Islands">Cook Islands</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Cote DIvoire">Cote DIvoire</option>
                                <option value="Croatia">Croatia</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Curaco">Curacao</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">Czech Republic</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Djibouti">Djibouti</option>
                                <option value="Dominica">Dominica</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="East Timor">East Timor</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Egypt">Egypt</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                <option value="Eritrea">Eritrea</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Falkland Islands">Falkland Islands</option>
                                <option value="Faroe Islands">Faroe Islands</option>
                                <option value="Fiji">Fiji</option>
                                <option value="Finland">Finland</option>
                                <option value="France">France</option>
                                <option value="French Guiana">French Guiana</option>
                                <option value="French Polynesia">French Polynesia</option>
                                <option value="French Southern Ter">French Southern Ter</option>
                                <option value="Gabon">Gabon</option>
                                <option value="Gambia">Gambia</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Gibraltar">Gibraltar</option>
                                <option value="Great Britain">Great Britain</option>
                                <option value="Greece">Greece</option>
                                <option value="Greenland">Greenland</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Guadeloupe">Guadeloupe</option>
                                <option value="Guam">Guam</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Guinea">Guinea</option>
                                <option value="Guyana">Guyana</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Hawaii">Hawaii</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Hong Kong">Hong Kong</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="India">India</option>
                                <option value="Iran">Iran</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Isle of Man">Isle of Man</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Jamaica">Jamaica</option>
                                <option value="Japan">Japan</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Kiribati">Kiribati</option>
                                <option value="Korea North">Korea North</option>
                                <option value="Korea Sout">Korea South</option>
                                <option value="Kuwait">Kuwait</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Laos">Laos</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Lesotho">Lesotho</option>
                                <option value="Liberia">Liberia</option>
                                <option value="Libya">Libya</option>
                                <option value="Liechtenstein">Liechtenstein</option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Macau">Macau</option>
                                <option value="Macedonia">Macedonia</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Maldives">Maldives</option>
                                <option value="Mali">Mali</option>
                                <option value="Malta">Malta</option>
                                <option value="Marshall Islands">Marshall Islands</option>
                                <option value="Martinique">Martinique</option>
                                <option value="Mauritania">Mauritania</option>
                                <option value="Mauritius">Mauritius</option>
                                <option value="Mayotte">Mayotte</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Midway Islands">Midway Islands</option>
                                <option value="Moldova">Moldova</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montserrat">Montserrat</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="Nambia">Nambia</option>
                                <option value="Nauru">Nauru</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Netherland Antilles">Netherland Antilles</option>
                                <option value="Netherlands">Netherlands (Holland, Europe)</option>
                                <option value="Nevis">Nevis</option>
                                <option value="New Caledonia">New Caledonia</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Niger">Niger</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="Niue">Niue</option>
                                <option value="Norfolk Island">Norfolk Island</option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Palau Island">Palau Island</option>
                                <option value="Palestine">Palestine</option>
                                <option value="Panama">Panama</option>
                                <option value="Papua New Guinea">Papua New Guinea</option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Peru">Peru</option>
                                <option value="Phillipines">Philippines</option>
                                <option value="Pitcairn Island">Pitcairn Island</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Puerto Rico">Puerto Rico</option>
                                <option value="Qatar">Qatar</option>
                                <option value="Republic of Montenegro">Republic of Montenegro</option>
                                <option value="Republic of Serbia">Republic of Serbia</option>
                                <option value="Reunion">Reunion</option>
                                <option value="Romania">Romania</option>
                                <option value="Russia">Russia</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="St Barthelemy">St Barthelemy</option>
                                <option value="St Eustatius">St Eustatius</option>
                                <option value="St Helena">St Helena</option>
                                <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                                <option value="St Lucia">St Lucia</option>
                                <option value="St Maarten">St Maarten</option>
                                <option value="St Pierre & Miquelon">St Pierre & Miquelon</option>
                                <option value="St Vincent & Grenadines">St Vincent & Grenadines</option>
                                <option value="Saipan">Saipan</option>
                                <option value="Samoa">Samoa</option>
                                <option value="Samoa American">Samoa American</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Sao Tome & Principe">Sao Tome & Principe</option>
                                <option value="Saudi Arabia">Saudi Arabia</option>
                                <option value="Senegal">Senegal</option>
                                <option value="Seychelles">Seychelles</option>
                                <option value="Sierra Leone">Sierra Leone</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="Solomon Islands">Solomon Islands</option>
                                <option value="Somalia">Somalia</option>
                                <option value="South Africa">South Africa</option>
                                <option value="Spain">Spain</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Swaziland">Swaziland</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Syria">Syria</option>
                                <option value="Tahiti">Tahiti</option>
                                <option value="Taiwan">Taiwan</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Tanzania">Tanzania</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Togo">Togo</option>
                                <option value="Tokelau">Tokelau</option>
                                <option value="Tonga">Tonga</option>
                                <option value="Trinidad & Tobago">Trinidad & Tobago</option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Turkmenistan">Turkmenistan</option>
                                <option value="Turks & Caicos Is">Turks & Caicos Is</option>
                                <option value="Tuvalu">Tuvalu</option>
                                <option value="Uganda">Uganda</option>
                                <option value="United Kingdom">United Kingdom</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Arab Erimates">United Arab Emirates</option>
                                <option defaultValue value="United States of America">United States of America</option>
                                <option value="Uraguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Vanuatu">Vanuatu</option>
                                <option value="Vatican City State">Vatican City State</option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Vietnam">Vietnam</option>
                                <option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
                                <option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
                                <option value="Wake Island">Wake Island</option>
                                <option value="Wallis & Futana Is">Wallis & Futana Is</option>
                                <option value="Yemen">Yemen</option>
                                <option value="Zaire">Zaire</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                            </select>
                            <ValidationErrorComponent
                                error={formState.errors.country}
                                type="required"
                                message="Country selection is required."
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="zipcode">Zip Code<span>*</span></label>
                            <input type="text" placeholder="Zip Code" id="zipcode" {...register("zipcode", { required: true, maxLength: 100 })} />
                            <ValidationErrorComponent
                                error={formState.errors.zipcode}
                                type="required"
                                message="Zip Code is required."
                            />
                            <ValidationErrorComponent
                                error={formState.errors.zipcode}
                                type="maxLength"
                                message="Max length exceeded."
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="select">
                            <label htmlFor="engine_variant">Please select your engine variant.<span>*</span></label>
                            <select id="engine_variant" {...register("engine_variant", { required: true })}>
                                <option defaultValue value="">Select an Engine Variant</option>
                                <option value="AE1107">AE1107</option>
                                <option value="BR700">BR700</option>
                                <option value="CF34">CF34</option>
                                <option value="CF6">CF6</option>
                                <option value="CFM56">CFM56</option>
                                <option value="CT7">CT7</option>
                                <option value="F110">F110</option>
                                <option value="F135">F135</option>
                                <option value="F404">F404</option>
                                <option value="F414">F414</option>
                                <option value="GE90">GE90</option>
                                <option value="GE9X">GE9X</option>
                                <option value="GEnx-1B">GEnx-1B</option>
                                <option value="GEnx-2B">GEnx-2B</option>
                                <option value="J85">J85</option>
                                <option value="LEAP-1A">LEAP-1A</option>
                                <option value="LEAP-1B">LEAP-1B</option>
                                <option value="LEAP-1C">LEAP-1C</option>
                                <option value="LM2500">LM2500</option>
                                <option value="LM500">LM500</option>
                                <option value="LM5000">LM5000</option>
                                <option value="LM6000">LM6000</option>
                                <option value="LM9000">LM9000</option>
                                <option value="LMS100">LMS100</option>
                                <option value="PP20">PP20</option>
                                <option value="T408">T408</option>
                                <option value="T64">T64</option>
                                <option value="T700">T700</option>
                                <option value="TF34">TF34</option>
                                <option value="Trent 700">Trent 700</option>
                                <option value="Trent 800">Trent 800</option>
                                <option value="Trent 7000">Trent 7000</option>
                                <option value="Trent 1000">Trent 1000</option>
                                <option value="Trent XWB">Trent XWB</option>
                            </select>
                            <ValidationErrorComponent
                                error={formState.errors.engine_variant}
                                type="required"
                                message="An engine variant is required."
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="select">
                            <label htmlFor="region">Please select your region.<span>*</span></label>
                            <select id="region" {...register("region", { required: true })}>
                                <option defaultValue value="">Select a Region</option>
                                <option value="Asia Pacific">Asia Pacific</option>
                                <option value="China">China</option>
                                <option value="East Europe Middle East Africa">East Europe Middle East Africa</option>
                                <option value="South America">South America</option>
                                <option value="North America">North America</option>
                                <option value="Western Europe">Western Europe</option>
                            </select>
                            <ValidationErrorComponent
                                error={formState.errors.region}
                                type="required"
                                message="A region is required."
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="select">
                            <label htmlFor="AOG_support">Is this inquiry in support of an AOG?</label>
                            <select id="AOG_support" {...register("AOG_support")}>
                                <option value="Yes">Yes</option>
                                <option defaultValue value="No">No</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="select">
                            <label htmlFor="end_user_support">Are you the End User for the items requested in this request?</label>
                            <select id="end_user_support" {...register("end_user_support")}>
                                <option value="Yes">Yes</option>
                                <option defaultValue value="No">No</option>
                            </select>
                        </div>
                    </div>

                    {["LEAP-1A", "LEAP-1B", "LEAP-1C", "GE9X"].includes(ENGINE_VARIANT) &&
                        <div className="form-group">
                            <label className="text-field" htmlFor="gta_number">Please provide your GTA# for GE/CFM.<span>*</span></label>
                            <input id="gta_number" type="text" {...register("gta_number", { required: true })} />
                            <ValidationErrorComponent
                                error={formState.errors.gta_number}
                                type="required"
                                message="A GTA# is required."
                            />
                        </div>
                    }
                    <div className="form-group">
                        <div className="select">
                            <label htmlFor="govt_contract">If inquiry is in support of a Government contract, please provide contract number and/or any other applicable information?</label>
                            <select id="govt_contract" {...register("govt_contract")}>
                                <option value="Yes">Yes</option>
                                <option defaultValue value="No">No</option>
                            </select>
                        </div>
                    </div>
                    {GOVT_CONTRACT === "Yes" &&
                        <div className="form-group">
                            <label className="text-field" htmlFor="govt_contract_number">Please provide your Government Contract Number:<span>*</span></label>
                            <input id="govt_contract_number" type="text" {...register("govt_contract_number", { required: true })} />
                            <ValidationErrorComponent
                                error={formState.errors.govt_contract_number}
                                type="required"
                                message="A government contract number is required."
                            />
                            <label className="text-field" htmlFor="govt_contract_details">Please provide any Additional Government Contract Details:</label>
                            <textarea id="govt_contract_details" {...register("govt_contract_details")} />
                        </div>
                    }
                    <div className="form-group">
                        <label className="text-field" htmlFor="missing_part_numbers">Do you have any part numbers or tooling you could not find in our catalog? Please add the root part number & name to the box below.</label>
                        <textarea id="missing_part_numbers" {...register("missing_part_numbers")} />
                    </div>

                    <div className="form-submit-wrapper">
                        <input type="submit" value="Submit For Request" />    
                    </div>

                </form>
            </div>
        </div>
    );
}

export default RequestCartForm;